import React, { PureComponent } from 'react'
import cx from 'classnames'
import { connect } from 'redaction'
import { compose, links, getProjectName } from 'helpers'
import toggleOpen from 'local_modules/toggleOpen'
import injectGlobals from 'local_modules/injectGlobals'

import MarketplaceList from '../MarketplaceList/MarketplaceList'
import LayersHeading from '../LayersHeading/LayersHeading'

import LayersList from './LayersList/LayersList'
import PageNavigation from './PageNavigation/PageNavigation'

import s from './Layers.scss'


const openedLayersList = [ 'heroes', 'lsc-video-download', 'marketplace' ]

class Layers extends PureComponent {

  UNSAFE_componentWillMount() {
    const { isMobile, projectName, toggleClose } = this.props

    if (isMobile && projectName === 'marketplace') {
      toggleClose()
    }
  }

  componentDidMount() {
    const { projectName, toggleClose } = this.props

    if (openedLayersList.includes(projectName)) {
      toggleClose()
    }
  }

  componentWillReceiveProps({ projectName: newProjectName }) {
    const { projectName, toggleClose } = this.props

    if (projectName !== newProjectName && openedLayersList.includes(newProjectName)) {
      toggleClose()
    }
  }

  render() {
    const {
      layers, projectName,
      isToggleActive, toggleOpen, toggleClose, isMobile,
    } = this.props

    return (
      <div className={s.container}>
        <LayersHeading
          isToggleActive={isToggleActive}
          toggleOpen={toggleOpen}
          toggleClose={toggleClose}
        >
          <PageNavigation projectName={projectName} />
        </LayersHeading>
        <div
          className={cx(s.layersList, {
            [s.active]: isToggleActive,
          })}
        >
          <div className={s.layersContainer}>
            <LayersList
              className={s.layersContent}
              layers={layers}
              onClick={toggleClose}
            >
              {
                ({ id }) => {
                  const isMarketplace = id === 36

                  return isMarketplace && (
                    <MarketplaceList
                      toggleClose={isMobile && toggleClose}
                    />
                  )
                }
              }
            </LayersList>
          </div>
        </div>
      </div>
    )
  }
}


export default compose(
  injectGlobals(({ globals }) => ({
    isMobile: globals.isMobile,
  })),
  connect({
    projectName: (state) => getProjectName(state),
    layers: (state) => {
      const { me: { layers } } = state
      const { routing: { locationBeforeTransitions: { pathname } } } = state

      const projectName = getProjectName(state)
      const reactLinks  = Object.keys(links).map((linkKey) => links[linkKey].root)

      const layersList = {
        public: [],
        service: [],
        business: [],
        none: [],
      }

      layers.forEach(({ id, link, title, menu = 'none' }) => {
        const updatedLink = ({
          '/?chapter=48': links.lscTransportControl.root,
          '/?chapter=36': links.marketplace.root,
          '/?chapter=360': links.marketplace.root,
        })[link] || link

        if (!layersList[menu]) {
          layersList[menu] = []
        }

        layersList[menu].push({
          id,
          title,
          link: projectName === 'marketplace' && updatedLink === links.marketplace.root ? null : updatedLink,
          isActive: pathname.includes(updatedLink),
          toOLD: !reactLinks.includes(updatedLink),
          // onLinkClick: () => {
          //   if (updatedLink === links.marketplace.root) {
          //     actions.marketplace.layersNavigation.setActive(true)
          //   }
          // },
        })
      })

      return layersList
    },
  }),
  toggleOpen({ isToggleActive: true }),
)(Layers)
